
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import store from '@/store'
import { register, code } from '@/apis/user.js'


Vue.use(ElementUI)

export default {
    data() {
        var validateRePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請確認密碼'));
            } else if (value !== this.formData.password) {
                callback(new Error('兩次密碼輸入不壹致!'));
            } else {
                callback();
            }
        };
        return {
            isLoading: false,
            id: '',
            formData: {
                name: "",
                gender: "",
                email: "",
                phoneNumber: "",
                code: "",
                password: "",
                repassword: ''
            },
            rules: {
                name: [
                    { required: true, message: '請填寫姓名', trigger: 'change' }
                ],
                gender: [
                    { required: true, message: '請選擇性別', trigger: 'change' }
                ],
                email: [
                    { required: true, message: '請填寫EMAIL', trigger: 'change' }
                ],
                phoneNumber: [
                    { required: true, message: '請填寫手機號', trigger: 'change' }
                ],
                code: [
                    { required: true, message: '請填寫驗證碼', trigger: 'change' }
                ],
                password: [
                    { required: true, message: '請填寫密碼', trigger: 'change' }
                ],
                repassword: [
                    { validator: validateRePass, trigger: 'blur' }
                ]
            },
            token: '',
            isSendCode: false,
            sendCodeText: '取得驗證碼',
            showSuccessMessage: false,
            //是否同意協議
            isAgreenAgreement: false
        }
    },
    mounted() {
        this.$refs['form'].resetFields();
    },
    methods: {
        async fromSubmit() {
            try {
                this.isLoading = true;
                const res = await register({
                    name: this.formData.name,
                    gender: this.formData.gender,
                    email: this.formData.email,
                    phoneNumber: this.formData.phoneNumber,
                    code: this.formData.code,
                    password: this.formData.password
                });
                const data = res.data || {};
                if (res && res.code == 0) {
                    this.token = data.iToken;
                    this.id = data.userId;
                    this.msgLook();
                } else {
                    if (res) this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
        handleRegister() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (this.isAgreenAgreement) {
                        this.fromSubmit();
                    } else {
                        //成功
                        this.$confirm('需同意《用戶協議》和《隱私政策》，是否同意？', '提示', {
                            confirmButtonText: '確定',
                            cancelButtonText: '取消'
                        }).then(async () => {
                            this.isAgreenAgreement = true;
                            await this.fromSubmit();
                        }).catch(() => {

                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async sendCode() {
            if (this.isSendCode) return;
            if (!this.formData.phoneNumber) {
                this.$message.warning('請輸入手機號')
                return;
            }
            this.isSendCode = true;
            try {
                const res = await code({
                    businessType: '註冊',
                    phoneNumber: this.formData.phoneNumber
                });
                if (res && res.code == 0) {
                    let s = 60;
                    this.sendCodeText = s + 's';
                    let intervalId = setInterval(() => {
                        s--;
                        if (s <= 0) {
                            this.sendCodeText = '取得驗證碼';
                            if (intervalId) clearInterval(intervalId);
                            this.isSendCode = false;
                            return;
                        }
                        this.sendCodeText = s + 's';
                    }, 1000)
                } else {
                    this.isSendCode = false;
                    if (res) this.$message.error(res.msg)
                }
            } catch (error) {
                this.isSendCode = false;
                this.$message.error(error.message);
            }
        },
        close() {
            this.$register.close();
        },
        msgLook() {
            // store.commit('SET_USERNAME', this.formData.name)
            // store.commit('SET_TOKENS', {
            //     token: this.token,
            //     refreshToken: ''
            // })
            this.$RegisterSuccess.open({
                token: this.token,
                name: this.formData.name,
                userId: this.id
            });
            this.close();
        },
        toLogin() {
            this.close();
            this.$login.open();
        }
    }
}
